var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as Const from "@utils/Const";
import * as cutil from "@utils/Cutil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
export default function BoardReply(props) {
    var _a;
    const { item, setItem, } = props;
    let token = localStorage.getItem(Const.TOKEN);
    let lang = localStorage.getItem(Const.LANG_TYPEA);
    const [items, setItems] = useState(null);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [postId, setPostId] = useState("");
    const [file, setFile] = useState([]);
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_POST,
        appPath: `/admin/board/post/${item.postId}`,
        appQuery: {},
        userToken: token,
        watch: item.postId,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                setTitle("");
                setContent("");
                setItems(data.body);
                setPostId(data.body.postid);
            }
            else {
                alert(data.body.message);
            }
        }
    }, [data]);
    // 버튼 클릭 시 input 만들기 (단일 파일만)
    const handleUpload = (e) => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = false; // 하나만 업로드
        // 필요시 허용 확장자 지정: input.accept = "*/*";
        input.onchange = (ev) => {
            var _a;
            const target = ev.currentTarget;
            const f = (_a = target.files) === null || _a === void 0 ? void 0 : _a[0];
            if (!f)
                return;
            handleSelectFile(f);
        };
        input.click();
    };
    // 첨부파일 처리 (단일 파일)
    const handleSelectFile = (f) => {
        // 이미 1개가 있으면 추가 업로드 불가 (교체를 원하면 setFile([newItem])만 호출하고 return 제거)
        if (file.length >= 1) {
            alert("하나만 업로드 가능합니다.");
            return;
        }
        const formData = new FormData();
        formData.append("files", f);
        const newItem = {
            name: f.name,
            url: URL.createObjectURL(f),
            file: f,
            formData: formData // 서버 전송용 FormData
        };
        // 단일 파일만 허용
        setFile([newItem]);
    };
    const handleView = () => {
        setItem((prev) => (Object.assign(Object.assign({}, prev), { type: "" })));
    };
    const replyAdd = (e) => __awaiter(this, void 0, void 0, function* () {
        var isOk = confirm(`해당 글에 답변하시겠습니까?`);
        if (!isOk)
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POST,
            appPath: `/admin/board/post/${item.postId}/reply`,
            appQuery: {
                title: title,
                content: content,
                writer: lang == Const.LANG_KOR ? "관리자" : "Admin",
            },
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                if (file.length > 0) {
                    fileAdd(data.body.replyId);
                }
                else {
                    alert("해당 문의내용에 답글 처리가 완료 되었습니다.");
                    location.reload();
                }
            }
            else {
                alert(data.body.message);
            }
        }
    });
    // 첨부파일 업로드 (단일 파일)
    const fileAdd = (replyId) => __awaiter(this, void 0, void 0, function* () {
        var _b, _c, _d;
        const first = file[0];
        const picked = (first === null || first === void 0 ? void 0 : first.file) ||
            ((_b = first === null || first === void 0 ? void 0 : first.formData) === null || _b === void 0 ? void 0 : _b.get("files")) || undefined;
        if (!picked) {
            alert("첨부파일을 찾을 수 없습니다.");
            return;
        }
        const formData = new FormData();
        formData.append("files", picked);
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POSTF,
            appPath: `/admin/file/reply/${replyId}`,
            appQuery: formData,
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                alert("해당 문의내용에 답글 처리가 완료 되었습니다.");
                location.reload();
            }
            else {
                alert((_d = (_c = data.body) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "파일 업로드 실패");
            }
        }
    });
    return (_jsx(_Fragment, { children: _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsx("div", Object.assign({ className: "board-header" }, { children: _jsxs("h4", { children: ["\uAC8C\uC2DC\uD310 \uAD6C\uBD84: ", item.depth2.menuName] }) })), items && _jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC791\uC131\uC790" }), _jsx("input", { type: "text", disabled: true, value: items.writer })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC81C\uBAA9" }), _jsx("input", { type: "text", disabled: true, value: items.title })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uB0B4\uC6A9" }), _jsx("textarea", { disabled: true, value: items.content })] })), _jsxs("div", Object.assign({ className: "row-file" }, { children: [_jsx("label", { children: "\uCCA8\uBD80\uD30C\uC77C" }), items.attachList.map((file) => (_jsx("div", Object.assign({ className: "row-detail-file" }, { children: _jsx("div", Object.assign({ className: "notice-detail-file", onClick: (e) => cutil.handleDownload(e, file, file.originalFileName) }, { children: _jsxs("a", Object.assign({ href: "#" }, { children: [file.originalFileName, _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M12 15.577L8.461 12.039L9.169 11.319L11.5 13.65V5H12.5V13.65L14.83 11.32L15.539 12.039L12 15.577ZM6.616 19C6.15533 19 5.771 18.846 5.463 18.538C5.155 18.23 5.00067 17.8453 5 17.384V14.961H6V17.384C6 17.538 6.064 17.6793 6.192 17.808C6.32 17.9367 6.461 18.0007 6.615 18H17.385C17.5383 18 17.6793 17.936 17.808 17.808C17.9367 17.68 18.0007 17.5387 18 17.384V14.961H19V17.384C19 17.8447 18.846 18.229 18.538 18.537C18.23 18.845 17.8453 18.9993 17.384 19H6.616Z", fill: "#0048FF" }) }))] })) }), file.fileId) }))))] }))] })), _jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC81C\uBAA9" }), _jsx("input", { type: "text", value: title, onChange: (e) => setTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uCCA8\uBD80\uD30C\uC77C" }), _jsx("input", { type: "text", disabled: true, value: (_a = file[0]) === null || _a === void 0 ? void 0 : _a.name }), _jsx("button", Object.assign({ className: "img-btn", onClick: (e) => handleUpload(e) }, { children: "\uD30C\uC77C \uC120\uD0DD" }))] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uB0B4\uC6A9" }), _jsx("textarea", { value: content, onChange: (e) => setContent(e.target.value) })] })), _jsx("div", Object.assign({ className: "board-footer" }, { children: _jsxs("div", Object.assign({ className: "btn-box" }, { children: [_jsx("button", Object.assign({ onClick: (e) => replyAdd(e) }, { children: "\uB2F5\uAE00" })), _jsx("button", Object.assign({ onClick: handleView }, { children: "\uCDE8\uC18C" }))] })) }))] }))] })) }));
}
;
